import styled, { css } from 'styled-components';
import { SpaceContainer } from './SpaceContainer';
import { SHADOW_TYPES } from '../shadows/shadows';
import { SIZES, PX_TO_REM } from '../sizes/sizes';

export const ModuleContainer = styled(SpaceContainer).attrs((args) => ({
  gutter: 16,
  ...args
}))`
  background-color: ${({ theme }) => theme.colours.base.white.colour};
  ${({ theme }) => theme.shadows.boxShadow[SHADOW_TYPES.DEFAULT]};
  border-radius: ${({ theme }) => theme.standardBorderRadius.medium};
  margin-bottom: ${({ theme }) => theme.spaces[16]};
  ${({ theme }) => css`
    @media only screen and (max-width: ${theme.breakpoints[SIZES.SMALL]}) {
      padding: ${PX_TO_REM[8]};
    }
  `}
`;
